var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"businesslicense"},[_c('img',{attrs:{"src":_vm.yingyezhizhao,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }